import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorPublishDialogComponent } from '../component/error-publish-dialog/error-publish-dialog.component';
import { PublishTosDialogComponent } from '../component/publish-tos-dialog/publish-tos-dialog.component';

@NgModule({
  declarations: [
    ErrorPublishDialogComponent,
    PublishTosDialogComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    FlexLayoutModule,

    MatButtonModule,
    MatDialogModule,
    MatCheckboxModule,
    MatDividerModule,
    MatProgressSpinnerModule,
  ],
})
export class PublishInvoiceModule {
}
